import { NavLink } from 'react-router-dom';
import { cn } from '../../utils/helpers';
import { SETTINGS_NAV } from './settingsNav';
import { useTranslation } from '../../hooks/useTranslation';

interface SettingsSidebarProps {
  /** Called after a nav item is chosen (used to close the mobile drawer). */
  onNavigate?: () => void;
}

/** Shared category navigation, rendered in both the desktop rail and mobile drawer. */
export default function SettingsSidebar({ onNavigate }: SettingsSidebarProps) {
  const { t } = useTranslation();
  return (
    <nav className="space-y-1">
      {SETTINGS_NAV.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.end}
          onClick={onNavigate}
          className={({ isActive }) =>
            cn(
              'flex items-center gap-3 rounded-2xl px-3 py-2.5 transition-all',
              isActive
                ? 'bg-neutral-900 dark:bg-neutral-100 text-white dark:text-neutral-900 shadow-lg shadow-neutral-900/20 dark:shadow-neutral-100/10'
                : 'text-neutral-600 dark:text-neutral-400 hover:bg-neutral-100 dark:hover:bg-neutral-800 hover:text-neutral-900 dark:hover:text-neutral-100',
            )
          }
        >
          {({ isActive }) => (
            <>
              <span
                className={cn(
                  'w-9 h-9 rounded-xl flex items-center justify-center shrink-0',
                  isActive ? 'bg-white/15 dark:bg-neutral-900/10' : 'bg-neutral-100 dark:bg-neutral-800',
                )}
              >
                <item.icon className="w-4 h-4" />
              </span>
              <span className="min-w-0">
                <span className="block text-sm font-semibold truncate">{t(item.labelKey)}</span>
                <span className={cn('block text-[11px] truncate', isActive ? 'text-white/60 dark:text-neutral-900/60' : 'text-neutral-400 dark:text-neutral-500')}>
                  {t(item.descriptionKey)}
                </span>
              </span>
            </>
          )}
        </NavLink>
      ))}
    </nav>
  );
}
